import NavigateOtherStory from './NavigateOtherStory'
import withNavigateOtherStory from './withNavigateOtherStory'

const ConnectedNavigateOtherStory = withNavigateOtherStory(NavigateOtherStory)

export { ConnectedNavigateOtherStory as NavigateOtherStory }
